import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import SupportCTA from './components/SupportCTA';
import Footer from './components/Footer';
import GuideSection from './components/GuideSection';

export default function App() {
  // Forced strict background colors to override any deployment CSS conflicts
  return (
    <div 
      className="min-h-screen text-white selection:bg-purple selection:text-white overflow-x-hidden relative"
      style={{ 
        backgroundColor: '#0D1B3E',
        backgroundImage: 'radial-gradient(circle at center, #0D1B3E 0%, #0A1628 100%)',
        backgroundAttachment: 'fixed'
      }}
    >
      <Navbar />
      <main className="max-w-7xl mx-auto px-0 sm:px-6 lg:px-8 pt-36 md:pt-48 pb-16 md:pb-24">
        <Hero />
        <GuideSection />
      </main>
      <SupportCTA />
      <Footer />
    </div>
  );
}